import React from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

const AccountantOnboardingView = ({ currentItem, handleView }) => {
  console.log("Current Item in Accountant View:", currentItem);
  const { t } = useTranslation();

  return (
    <>
      <div className="inset-0 z-50 outline-none justify-center items-center flex overflow-x-hidden overflow-y-auto fixed focus:outline-none">
        <div className="mx-auto relative w-auto my-6 max-w-3xl">
          <form className="py-8 sm:py-4 sm:px-2 px-7">
            <div className="min-w-[940px] max-h-[96vh] border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none overflow-y-auto">
              <div className="border-slate-200 flex items-center justify-between p-5 border-b border-solid rounded-t">
                <h3 className="font-semibold text-xl">{t("VIEW_ACCOUNTANT_ONBOARDING")}</h3>
                <button 
                  onClick={() => handleView(false)} 
                  className="rounded-full h-8 w-8 float-right ml-auto flex items-center justify-center text-black border-2 text-3xl leading-none font-extralight outline-none focus:outline-none"
                >
                  <span className="text-[#B8BBBF] text-4xl" title="Close">
                    ×
                  </span>
                </button>
              </div>
              <div className="p-6 relative flex-auto">
                <h3 className="font-semibold text-xl">Personal details</h3>
                <div className="grid grid-cols-3">
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Accountant ID</strong>
                      <h6>{currentItem.accountantId || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="z-0 mb-2 relative w-full group">
                      <strong>Accountant name</strong>
                      <h6>{currentItem.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:px-2 sm:py-4 py-8 px-7">
                    <div className="w-full relative z-0 mb-2 group">
                      <strong>Email ID</strong>
                      <h6>{currentItem.email || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Mobile number</strong>
                      <h6>
                        +({currentItem?.countryCode}) {currentItem?.mobile}
                      </h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="mb-2 relative z-0 w-full group">
                      <strong>Country</strong>
                      <h6>{currentItem.Country?.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="group relative z-0 mb-2 w-full">
                      <strong>State</strong>
                      <h6>{currentItem.State?.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="group relative z-0 mb-2 w-full">
                      <strong>City</strong>
                      <h6>{currentItem.city || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 py-8 sm:px-2 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Address</strong>
                      <h6>{currentItem.address || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Created date</strong>
                      <h6>{dayjs(currentItem?.createdAt).format("MM-DD-YYYY hh:mm A")}</h6>
                    </div>
                  </div>
                  <div className="pt-8 pb-0 sm:pt-4 sm:px-2 px-7">
                    <div className="relative z-0 mb-0 w-full group">
                      <strong>Profile image</strong>
                      <img 
                        className="w-16 rounded-full h-16" 
                        src={currentItem?.profilePicture || "./images/user.png"} 
                        alt="Profile" 
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="z-40 opacity-25 fixed inset-0 bg-black" />
    </>
  );
};

export default AccountantOnboardingView;